import { format } from 'date-fns';
import { memo } from 'react';
import { getDateFnsLocale } from '../../../../utils';

import classNames from 'classnames';
import classes from './EventDateBadge.module.scss';

interface EventDateBadgeProps {
  date: Date;
  className?: string;
}

export const EventDateBadge = memo(({ date, className }: EventDateBadgeProps) => {
  const locale = getDateFnsLocale();

  return (
    <div className={classNames(classes['event-date-badge'], className)}>
      <span className={classes['event-date-badge__month']}>
        {format(date, 'LLL', { locale }).toUpperCase()}
      </span>
      <span className={classes['event-date-badge__day']}>{format(date, 'd')}</span>
      <span className={classes['event-date-badge__weekday']}>
        {format(date, 'EEEEEE', { locale }).toUpperCase()}
      </span>
    </div>
  );
});
